import { render, staticRenderFns } from "./4_CommentsDetails.vue?vue&type=template&id=6ee9dd30&"
import script from "./4_CommentsDetails.vue?vue&type=script&lang=js&"
export * from "./4_CommentsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports